import { Component, Input, OnInit } from '@angular/core';
import { AverageTicketVolume } from '../../../../shared/models/EvoSalesPortalModel';
import { DashboardService } from '../../../../shared/services/dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BindingContext } from '../../../../shared/models/BindingContext';
import { DashboardWidget } from '../../dashboard-interface';

@Component({
    selector: 'app-dashboard-vol',
    templateUrl: './dashboard-vol.component.html',
    styleUrls: ['./dashboard-vol.component.scss'],
    host: { 'class': 'col-md-6 col-lg-4' }
})
export class DashboardVolComponent extends DashboardWidget implements OnInit {
    @Input() title: string;
    @Input() color = 'white';
    @Input() url: string;
    @Input() bindingContext:BindingContext;
    
    public yearlyVol: Array<AverageTicketVolume>;
    public monthlyVol: Array<AverageTicketVolume>;
    public salesTabName: string;
    private dashboardError: string = "Error loading dashboard item, please contact support."

    constructor(private dashboardSvc: DashboardService) {
        super();
        this.yearlyVol = new Array<AverageTicketVolume>();
        this.monthlyVol = new Array<AverageTicketVolume>();
    }

    ngOnInit() {
        //Do stuff
        this.salesTabName = 'M';
        this.getData();
    }

    //Changes the chart from month to year and back again - a hobbits tale
    public changeTimeScale(name: any) {
        //Changed ticket sales
        this.salesTabName = name;
    }

    private getData() {
        this.bindingContext.beginGet();
        this.dashboardSvc.getAverageTicketVolume().subscribe(
            resp => {
                this.bindingContext.endGet();
                //console.log(resp);
                this.monthlyVol = resp.filter(item => item.Scale == 'M');
                this.yearlyVol = resp.filter(item => item.Scale == 'Y');
                //console.log(this.yearlyVol);
                //console.log(this.monthlyVol);
            },
            (response: HttpErrorResponse) => {
                this.bindingContext.endGet();
                this.bindingContext.showAlert(BindingContext.alertType.danger, this.dashboardError,true);
            }
        );
    }

}
